export default {
  en: {
    global: {
      required: 'The {field} field is required.',
      email: 'E-mail is not valid',
      numeric: '{field} has to be numeric',
      between: 'Number {field} has to be between {min} and {max}',
      maxLength: '{field} length has to be at most {max} characters in lenght',
      minLength: '{field} length has to be at least {min} characters in lenght',
      maxValue: '{field} can not be over {max}',
      minValue: '{field} has to be at least {min}',
      url: 'Url is not valid'
    },
    custom: {},
    attributes: {
      'user.login': 'User login',
      'user.name': 'User name',
      'user.email': 'User email',
      'webHook.webHookUri': 'Uri'
    }
  },
  sr: {
    global: {
      required: '{field} је обавезно поље.',
      email: 'Имејл адреса није валидна.',
      numeric: '{field} може да садржи само бројеве',
      between: '{field} мора бити између {min} и {max}.',
      maxLength: '{field} мора имати највише {max} карактера',
      minLength: '{field} мора имати најмање {min} карактера',
      maxValue: '{field} не може бити преко {max}',
      minValue: '{field} не може бити испод {min}',
      url: 'Интернет адреса није валидна.',
      supportEmails: 'Опциона листа еМаил адреса за подршку није валидна',
      supportPhoneNumbers: '{field} може да садржи само бројеве и карактере ()/\\+-'
    },
    custom: {
      form: {
        name: {
          required: 'Upisi ime',
          minLength: 'Ime mora imati najmanje 5 karaktera'
        }
      }
    },
    attributes: {
      'register.id': 'JBKJS',
      'register.companyNumber': 'Матични број',
      'register.taxIdNumber': 'ПИБ',
      'register.executionAccount': 'Рачун извршења буџета',
      'register.name': 'Назив правног лица/органа',
      'register.companyName': 'Име компаније',
      'register.legalEntityName': 'Име јавног предузећа',
      'register.address': 'Адреса седишта',
      'register.treasuryBranch': 'Испостава трезора',
      'register.email': 'Имејл компаније',
      'register.phoneNumber': 'Телефон компаније',
      'register.adminName': 'Име и презиме',
      'register.adminIdentityNumber': 'Број личне карте',
      'register.adminEmail': 'Админ и-мејл',
      'register.adminPhoneNumber': 'Админ телефон',
      'register.supportEmails': 'Опциона листа еМаил адреса за подршку',
      'register.supportPhoneNumbers': 'Опциона листа телефона за подршку',
      'user.login': 'Корисничко име',
      'user.password': 'Лозинка',
      'user.newPassword': 'Нова лозинка',
      'user.name': 'Име и презиме',
      'user.email': 'Имејл корисника',
      'role.name': 'Назив улоге',
      'role.description': 'Опис улоге',
      'webHook.webHookUri': 'Интернет адреса примаоца',
      'project.name': 'Назив нацрта пројекта',
      'project.description': 'Опис нацрта пројекта',
      'project.type': 'Тип пројекта',
      'project.sector': 'Сектор',
      'project.code': 'Радни назив',
      'project.number': 'Идентификатор',
      'organization.adminLogin': 'Корисничко име администратора',
      'organization.nameShort': 'Скраћени назив',
      'organization.supportPhoneNumbers': 'Опциона листа телефона за подршку',
      'organization.supportEmails': 'Опциона листа еМаил адреса за подршку'
    }
  }
}
